import { render, staticRenderFns } from "./PTextarea.vue?vue&type=template&id=6c113e86"
import script from "./PTextarea.vue?vue&type=script&lang=js"
export * from "./PTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports